import React from 'react'
import _map from 'lodash/map'
import SelectTimeSlotAddon from './SelectTimeSlotAddons'

const getCheckboxes = (groupedTickets, defaultTicketIds) => {
  const checked = {}
  for (const group of groupedTickets) {
    for (const ticket of group.tickets) {
      if (defaultTicketIds.includes(ticket.id)) {
        checked[group.groupId] = true
        continue
      }
    }
  }
  return checked
}

const SelectTimeSlotTicketsAddons = props => {
  const { groupedTickets, defaultTicketIds } = props
  const checkboxes = getCheckboxes(groupedTickets, defaultTicketIds)

  const onChange = (v, groupId) => {
    props.onChange(v, groupId)
  }

  const onChecked = (tickets, groupId) => {
    props.onChange(tickets.map(ticket => ticket.id), groupId)
  }

  return (
    <div>
      {_map(groupedTickets, el => (
        <div key={el.groupId} style={{ clear: 'both' }}>
          <input
            id={el.groupId}
            type="checkbox"
            checked={!!checkboxes[el.groupId]}
            onChange={() => onChecked(!checkboxes[el.groupId] ? el.tickets : [], el.groupId)}
          />
          <label style={{ marginLeft: 10 }}>{el.groupName}</label>
          {checkboxes[el.groupId] ? (
            <SelectTimeSlotAddon
              onChange={v => onChange(v, el.groupId)}
              timeSlots={el.tickets}
              defaultTicketIds={defaultTicketIds}
            />
          ) : null}
        </div>
      ))}
    </div>
  )
}

export default SelectTimeSlotTicketsAddons
